export default __webpack_public_path__ + "static/media/scribble-arrow.daa427f3.svg";